import { Box, Typography } from '@mui/material';
import LoaderComponent from 'components/Loader';
import { LABELS } from '../constants';

export interface MostImpactedAppData {
  name: string;
  count: number;
}

interface MostImpactedAppProps {
  data: MostImpactedAppData[];
  isLoading: boolean;
  type?: string;
}

const MostImpactedApp = ({ data, isLoading, type }: MostImpactedAppProps) => {
  if (isLoading) return <LoaderComponent />;

  if (!data || data.length === 0) {
    return <Box sx={{ width: '100%', p: 2, textAlign: 'center' }}>No data available</Box>;
  }

  const maxCount = Math.max(...data.map((d) => d.count));
  const label = LABELS[type ?? ''] || type || "Alerts"

  return (
    <Box sx={{ width: '75%' }}>
      <Typography variant="h4" sx={{ fontWeight: 500, mb: 3, color: 'primary.main' }}>Most Impacted Applications - {label}</Typography>
      <Box>
        {data.map((item) => (
          <Box key={item.name} sx={{ mb: '4x' }}>
            <Typography sx={{ fontSize: '1rem', fontWeight: 500, color: 'text.primary', mb: 0.5 }}>
              {item.name}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ width: '100%', height: 28, position: 'relative' }}>
                <Box
                  sx={{
                    width: `${(item.count / maxCount) * 100}%`,
                    height: '100%',
                    backgroundColor: '#FF6B35',
                    borderRadius: 5,
                    transition: 'width 0.6s ease',
                  }}
                />
              </Box>
              <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: '#000', whiteSpace: 'nowrap', minWidth: '100px' }}>
                {item.count.toLocaleString('en-US')} {label}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default MostImpactedApp;
